import React from "react";

const DefineAssumedPopOver = () => {
  return (
    <>
      <h1 className="title">Assumed knowledge</h1>
      <p>
        It will be assumed that you have studied this HSC subject when you start
        this uni course. If you haven’t, you can still be selected for the
        course, but you may find it difficult to keep up.
      </p>
    </>
  );
};

export default DefineAssumedPopOver;
